<div class="stage-cards-table-container">
    <div class="max-w-7xl mx-auto px-3 mb-4">
      
      <!-- Table View (Always Visible) -->
      <div class="table-responsive">
        <table class="stage-cards-table">
          <thead>
            <tr>
              <th>Stage</th>
              <th>Count</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (card of stageCards; track card.stage) {
              <tr 
                class="stage-table-row hover:bg-gray-50 cursor-pointer transition-colors"
                (click)="onCardClick(card.stage)"
                role="button"
                tabindex="0"
                (keydown.enter)="onCardClick(card.stage)"
              >
                <td class="stage-cell">
                  <div class="flex items-center gap-3">
                    <div class="stage-indicator" [ngStyle]="{'background-color': card.color}"></div>
                    <div>
                      <div class="font-semibold text-gray-800">{{ card.label }}</div>
                      @if (card.description) {
                        <div class="text-xs text-gray-500 mt-0.5">
                          {{ card.description }}
                        </div>
                      }
                      <div class="text-xs font-medium px-2 py-1 rounded-full inline-block mt-1"
                           [ngStyle]="{'background-color': card.color + '20', 'color': card.color}">
                        {{ card.stage }}
                      </div>
                    </div>
                  </div>
                </td>
                
                <td class="count-cell">
                  <div class="text-2xl font-bold" [ngStyle]="{'color': card.color}">
                    <!-- Show count if loading, otherwise show value -->
                    @if (loading) {
                      <div class="h-8 bg-gray-200 rounded w-16 animate-pulse inline-block"></div>
                    } @else {
                      {{ getDisplayCount(card.stage) | number }}
                    }
                  </div>
                  <div class="text-xs text-gray-500 mt-1">
                    Projects
                  </div>
                </td>
                
                <td class="action-cell">
                  @if (showActionButton) {
                    <button 
                      class="view-details-btn text-sm font-medium px-3 py-1.5 rounded transition-colors flex items-center"
                      [ngStyle]="{
                        'background-color': card.color,
                        'color': 'white',
                        'border': '1px solid ' + card.color
                      }"
                      (click)="onViewDetails($event, card.stage)"
                      [attr.aria-label]="'View details for ' + card.label"
                      [disabled]="loading"
                    >
                      @if (loading) {
                        <i class="pi pi-spin pi-spinner mr-1 text-xs"></i>
                        Loading...
                      } @else {
                        View Details
                        <i class="pi pi-arrow-right ml-1 text-xs"></i>
                      }
                    </button>
                  } @else {
                    <div class="text-gray-400">
                      <i class="pi pi-arrow-right"></i>
                    </div>
                  }
                </td>
              </tr>
            }
            
            <!-- Show empty state if no cards -->
            @if (stageCards.length === 0) {
              <tr>
                <td colspan="3" class="text-center py-8 text-gray-500">
                  <i class="pi pi-inbox text-3xl mb-2 block"></i>
                  <p>No stage data available</p>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>